import { Loader, Skeleton } from '@mantine/core'
import { translate } from 'i18n/i18n'

const SectionLoader = ({ title }: { title: string }) => (
  <div>
    <div css={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
      <h3 css={{ margin: 0 }}>{title}</h3>
      <Loader size="sm" color="blue" />
    </div>
    <Skeleton height={250} radius="sm" animate />
  </div>
)

export const IrrigationSkeleton = () => (
  <div css={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
    <SectionLoader title={translate.phrases.banyanApp('Irrigation Planning Table')} />
    <Skeleton height={60} radius="sm" animate />
    <SectionLoader title={translate.phrases.banyanApp('Irrigation Scheduler (Hours)')} />
    <Skeleton height={60} radius="sm" animate />
    <SectionLoader title={translate.phrases.banyanApp('Crop Water Consumption (ETc)')} />
    <Skeleton height={60} radius="sm" animate />
  </div>
)
